import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaUserCheck,
  FaUmbrellaBeach,
  FaMoneyBill,
  FaTasks,
  FaChartLine,
  FaUserCircle,
  FaBell,
} from "react-icons/fa";
import axios from "axios";
import { API_URL } from "../../config";

function SideBar() {
  const [unreadCount, setUnreadCount] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));
  const employeeId = user?.employeeId;

  const fetchUnreadCount = async () => {
    if (!employeeId) return;
    try {
      const res = await axios.get(
        `${API_URL}/api/notifications/employee/unread/${employeeId}`
      );
      if (res.data.success) {
        setUnreadCount(res.data.unread);
      }
    } catch (err) {
      console.error("Error fetching unread count:", err);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, [employeeId]);

  const navClass = ({ isActive }) =>
    `emp-nav-item${isActive ? " active" : ""}`;

  return (
    <aside className="emp-sidebar">
      <div className="emp-sidebar-brand">
        <h4>Employee CRM</h4>
        <p>Productivity Workspace</p>
      </div>

      <NavLink to="/employee" end className={navClass}>
        <span className="emp-nav-left">
          <FaHome />
          Home
        </span>
      </NavLink>

      <NavLink to="/employee/employeeattendance" className={navClass}>
        <span className="emp-nav-left">
          <FaUserCheck />
          Attendance
        </span>
      </NavLink>

      <NavLink to="/employee/LeavePage" className={navClass}>
        <span className="emp-nav-left">
          <FaUmbrellaBeach />
          Leaves
        </span>
      </NavLink>

      <NavLink to="/employee/salaryPage" className={navClass}>
        <span className="emp-nav-left">
          <FaMoneyBill />
          Salary
        </span>
      </NavLink>

      <NavLink to="/employee/employeeTask" className={navClass}>
        <span className="emp-nav-left">
          <FaTasks />
          Tasks
        </span>
      </NavLink>

      <NavLink to="/employee/employeeNotification" className={navClass}>
        <span className="emp-nav-left">
          <FaBell />
          Notifications
        </span>
        {unreadCount > 0 ? <span className="badge bg-danger rounded-pill">{unreadCount}</span> : null}
      </NavLink>

      <NavLink to="/employee/performance" className={navClass}>
        <span className="emp-nav-left">
          <FaChartLine />
          Performance
        </span>
      </NavLink>

      <NavLink to="/employee/profile" className={navClass}>
        <span className="emp-nav-left">
          <FaUserCircle />
          Profile
        </span>
      </NavLink>
    </aside>
  );
}

export default SideBar;
